module.exports = __webpack_public_path__ + "img/male.8029f4ed.svg";